import { render, staticRenderFns } from "./press.vue?vue&type=template&id=170c8bca&scoped=true&"
var script = {}
import style0 from "./press.vue?vue&type=style&index=0&id=170c8bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170c8bca",
  null
  
)

export default component.exports